import { createRequest, RequestConfig } from '../../../core/libs/api';
import { TTariffType } from '../../buy-ticket/types';
import { TOrder } from '../../orders/core/order';
import { TTariffOrder } from '../../tariffs/types';
import { TTrip } from '../../trips/trip';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_ticket_orders2',
};

export type OrdersData = {
  orders: TOrder[];
  tariffTypes: TTariffType[];
  trips: TTrip[];
  tariffs: TTariffOrder[];
};

export const getTicketOrdersRequest = (status?: number) =>
  createRequest({
    url: config.url,
    query: status ? { type: String(status) } : undefined,
    method: config.method,
  });
